<template>
  <div>
    <tooltip label="View" type="default" placement="left">
      <a class="button button-table is-small" @click="url(this.data)">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
    <tooltip label="Refund" type="default" placement="left" v-if="parseInt(this.data.refund_client) == 0 || parseInt(this.data.refund_provider) == 0">
      <a class="button button-table is-small" @click="refund(this.data)">
        <i class="fa fa-reply"></i>
      </a>
    </tooltip>
    <tooltip label="Skip Refund" type="default" placement="left" v-if="(parseInt(this.data.refund_client) == 0 || parseInt(this.data.refund_provider) == 0)">
      <a class="button button-table is-small" @click="skip(this.data)">
        <i class="fa fa-arrow-right"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import Refund from '../finances/refund'
  import message from '../../utils/message'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip,
      Refund
    },
    methods: {
      url (data) {
        window.open('#/services/service/' + this.data.id)
      },
      view () {
        this.$router.push({name: 'Service', params: {id: this.data.id}})
      },
      refund () {
        let propsData = {
          context: this,
          service: this.data,
          callback: 'refundCallback'
        }
        Refund.openRefund(propsData)
      },
      refundCallback (result) {
        this.$parent.loadData(true)
      },
      skip () {
        let propsData = {
          context: this,
          service: this.data,
          callback: 'skipRefundCallback'
        }
        Refund.openSkipRefund(propsData)
      },
      skipRefundCallback (result) {
        this.$parent.loadData(true)
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// RefundsTableButtons.vue?1eb3557c